import React, { useMemo } from 'react';
import BarDataCard from 'src/App/Dashboards/Market/Components/Cards/BarDataCard';
import { exchangeRates } from 'src/utils/const';
import { COLOR_PRIMARY_1, COLOR_PRIMARY_1_700 } from 'src/utils/colors';
import { getDynamicExtraFees } from 'src/utils/functions';
import { Grid } from '@mui/material';
import { LoadingCard } from 'src/App/Dashboards/Market/Components';
import NoDataCard from 'src/App/Dashboards/Market/Components/Cards/NoDataCard';

const ExtraPricingCard = ({
  currency,
  cachedData,
  viewMode,
  isDynamicLoading,
  multipleMarkersCallLoading,
  noDataInMarket,
}: {
  currency: string;
  cachedData?: { [key: string]: number } | null;
  viewMode: 'map' | 'dashboard' | 'discovery' | 'compare' | 'advance' | 'searchListing';
  isDynamicLoading: boolean;
  multipleMarkersCallLoading: Boolean;
  noDataInMarket: boolean;
}) => {
  const isDataStatic = viewMode === 'dashboard' && cachedData;
  const isDataLoading = multipleMarkersCallLoading && !isDataStatic;

  const dynamicExtraFees = useMemo(() => {
    if (isDataLoading) return [];
    return getDynamicExtraFees(currency, isDataStatic ? cachedData : null);
  }, [currency, viewMode, cachedData]);

  if (isDataLoading || isDynamicLoading) {
    return <LoadingCard height={150} type="bars" />;
  }

  if (noDataInMarket) {
    return <NoDataCard height={150} borderRadius={8} />;
  }

  return (
    <Grid
      container
      direction="column"
      justifyContent="center"
      item
      xs={12}
      spacing={1}
      sx={{ padding: '5px', boxShadow: '0 4px 10px #0003', borderRadius: 1 }}
    >
      <BarDataCard
        title="Extra Pricing"
        tooltipContent="Other fees counted as income. Cleaning Fee is the typical fee charged per booking. Extra Guest Fee is an estimate of the fee charged per additional guest."
        data={dynamicExtraFees}
        orientation="vertical"
        unit={exchangeRates[currency].symbol}
        isCurrency={true}
        graphHeight={150}
        barColor={COLOR_PRIMARY_1_700}
        barAccentColor={COLOR_PRIMARY_1}
        parent="extra_pricing"
      />
    </Grid>
  );
};

export default ExtraPricingCard;
